import { ReactNode } from "react";
import logoFull from "../../assets/logo-full.png";
import {
  authPageBgClass,
  authSurfaceGlowOverlayClass,
  authSurfaceVignetteOverlayClass,
} from "./authStyles";

export {
  authCardClass,
  authLinkClass,
  authIconClass,
  authDividerLineClass,
  authMutedTextClass,
  authTitleClass,
  authSubtitleClass,
  authSurfaceGradientClass,
  authSurfaceGlowOverlayClass,
  authSurfaceVignetteOverlayClass,
} from "./authStyles";

type Props = {
  children: ReactNode;
  /** Conteúdo opcional na coluna esquerda (desktop) */
  aside?: ReactNode;
};

export function AuthLayout({ children, aside }: Props) {
  return (
    <div className={authPageBgClass}>
      <div className={authSurfaceGlowOverlayClass} aria-hidden />
      <div className={authSurfaceVignetteOverlayClass} aria-hidden />

      <div className="relative z-10 mx-auto flex min-h-screen max-w-6xl flex-col lg:flex-row">
        <aside className="relative hidden w-full flex-1 flex-col justify-between px-10 py-14 text-white lg:flex lg:max-w-md xl:max-w-lg">
          <div>
            <div className="mb-10">
              <AuthBrandAside />
            </div>
            {aside ?? (
              <div className="space-y-5">
                <p className="text-balance text-2xl font-semibold leading-snug tracking-tight text-white/95">
                  Gestão de eventos, credenciamentos e presença em um só lugar.
                </p>
                <p className="max-w-md text-sm leading-relaxed text-white/75">
                  Painel oficial APCAP Brasil — experiência segura e moderna
                  para equipes e participantes.
                </p>
                <ul className="mt-8 space-y-3 text-sm text-white/65">
                  <li className="flex items-center gap-2">
                    <span className="h-1.5 w-1.5 rounded-full bg-emerald-400" />
                    Acesso criptografado e sessão protegida
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="h-1.5 w-1.5 rounded-full bg-emerald-400" />
                    Interface responsiva em qualquer dispositivo
                  </li>
                </ul>
              </div>
            )}
          </div>
          <p className="text-xs text-white/45">
            © {new Date().getFullYear()} Aprender e Capacitar Brasil
          </p>
        </aside>

        <main className="flex flex-1 flex-col items-center justify-center px-4 py-10 sm:px-8 lg:py-14">
          <div className="w-full max-w-[26rem]">{children}</div>
        </main>
      </div>
    </div>
  );
}

function AuthBrandAside() {
  return (
    <div className="flex items-center rounded-2xl border border-white/15 bg-white/[0.07] px-5 py-4 shadow-lg shadow-black/25 ring-1 ring-white/10 backdrop-blur-sm">
      <img
        src={logoFull}
        alt="Aprender e Capacitar Brasil"
        className="h-14 w-auto max-w-[min(100%,320px)] object-contain object-left drop-shadow-md"
        width={560}
        height={240}
        decoding="async"
        loading="eager"
      />
    </div>
  );
}
